import { Place } from '@mui/icons-material';
import { Button, CardActions, Grid } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/styles';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ShowMoreText from 'react-show-more-text';
import {
    useDeleteBookingMutation,
    useSetEventReminderMutation,
} from '../../api/apiSlice';

export default function KanisaActionCard({
    id,
    name,
    venue,
    desc,
    date,
    time,
    num,
    bookCategory,
    event,
    service,
    appointment,
    booking,
    link,
    reminder,
    serviceInner,
}) {
    const [buttonTitle, setButtonTitle] = useState();
    const [reminderStatus, setReminderStatus] = useState(reminder?.set);

    const theme = useTheme();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [deleteBooking] = useDeleteBookingMutation();
    const [setEventReminder] = useSetEventReminderMutation();

    useEffect(() => {
        booking && setButtonTitle('Cancel Booking');
        service && setButtonTitle('Book Seat');
        appointment && setButtonTitle('Book Space');
    }, [appointment, booking, service]);

    return (
        <Grid item xs={12}>
            <Card
                variant="outlined"
                style={{
                    borderRadius: theme.shape.borderRadius,
                    borderWidth: 2,
                }}
            >
                <CardContent>
                    <Typography style={{ fontWeight: 'bold' }} variant="h6">
                        {name}
                    </Typography>
                    <Typography variant="h6">
                        {booking && `Category: ${bookCategory}`}
                    </Typography>
                    <Typography>{venue?.name}</Typography>
                    <ShowMoreText lines={2} more="more" less="less">
                        {desc}
                    </ShowMoreText>

                    {(service || appointment || booking) && (
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                            }}
                        >
                            <div>
                                <Typography variant="h4">{num}</Typography>
                                <Typography variant="h6">
                                    {service && 'Seats left'}
                                    {appointment && 'Spaces Left'}
                                    {booking && 'Booked'}
                                </Typography>
                            </div>

                            <div>
                                <Typography variant="h6">{date}</Typography>
                                <Typography variant="h6">{time}</Typography>
                            </div>
                        </div>
                    )}
                    {event && (
                        <>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                }}
                            >
                                <Typography>
                                    {moment(date).format('MMM Do YYYY')}
                                </Typography>
                                <Typography>{time}</Typography>
                            </div>
                            <div className="d-flex justify-content-between">
                                <Button
                                    size="medium"
                                    variant="outlined"
                                    className="text-capitalize"
                                    startIcon={<Place />}
                                    onClick={() => {
                                        navigate('/event-map', {
                                            state: {
                                                position: {
                                                    lat: venue?.latitude,
                                                    lng: venue?.longitude,
                                                },
                                            },
                                        });
                                    }}
                                >
                                    Location
                                </Button>
                                <Button
                                    variant={
                                        reminderStatus
                                            ? 'outlined'
                                            : 'contained'
                                    }
                                    size="medium"
                                    className="text-capitalize"
                                    onClick={() => {
                                        setEventReminder(id);
                                        setReminderStatus(!reminderStatus);
                                    }}
                                >
                                    {reminderStatus
                                        ? 'Drop Reminder'
                                        : 'Set Reminder'}
                                </Button>
                            </div>
                        </>
                    )}
                </CardContent>
                {!event && !serviceInner && (
                    <CardActions
                        style={{
                            justifyContent: 'center',
                        }}
                    >
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={() => {
                                booking && dispatch(deleteBooking({ id }));
                                (appointment || service) && navigate(link);
                            }}
                        >
                            {buttonTitle}
                        </Button>
                    </CardActions>
                )}
            </Card>
        </Grid>
    );
}
